import Swiper from "./swiper-bundle.esm.browser.min.js";

if (!customElements.get("secondary-nav")) {
  customElements.define(
    "secondary-nav",
    class SecondaryNav extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.scrollableElement = this.querySelector(
          ".secondary-navigation__ul",
        );
        this.container = this.querySelector(".secondary-navigation");
        this.swiperEl = this.querySelector('.swiper');
        this.dataCenterSlides = this.dataset.centerSlides === '';

        this.initSwiper();
        this.initTabs();
      }

      initTabs() {
        const tabButtons = this.querySelectorAll('[data-tab]');
        if (!tabButtons.length) return;

        tabButtons.forEach((button) => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            
            // Remove active class from all tabs and slides
            tabButtons.forEach((btn) => {
              btn.classList.remove('active', 'secondary-navigation__link--active');
              btn.setAttribute('aria-selected', 'false');
              btn.closest('.secondary-navigation__swiper-slide')?.classList.remove('secondary-navigation__swiper-slide--active');
            });

            // Add active class to clicked tab
            button.classList.add('active', 'secondary-navigation__link--active');
            button.setAttribute('aria-selected', 'true');
            button.closest('.secondary-navigation__swiper-slide')?.classList.add('secondary-navigation__swiper-slide--active');

            // Handle tab panel visibility
            const targetId = button.dataset.tabTarget;
            if (targetId) {
              const section = this.closest('[data-section-id]');
              const tabPanels = section?.querySelectorAll('[data-tab-content]');
              
              tabPanels?.forEach((panel) => {
                if (panel.dataset.sectionTarget === targetId) {
                  panel.classList.remove('tw-hidden');
                  panel.classList.add('tw-block');
                } else {
                  panel.classList.remove('tw-block');
                  panel.classList.add('tw-hidden');
                }
              });
            }
          });
        });
      }

      initSwiper(){
        // functions        
        const scrollToActiveSlide = (swiperEvent) => {
          const activeClass = 'secondary-navigation__swiper-slide--active'
          const slides = [...swiperEvent.slides];

          const activeSlideIndex = slides.findIndex((el) => el.classList.contains(activeClass));
          if (activeSlideIndex) {
            const speed = activeSlideIndex * 220
            swiperEvent.slideTo(activeSlideIndex, speed, true)
          }
        }

        const centerSlides = (swiperEvent) => {
          const shouldBeCentered = swiperEvent.snapGrid.length === 1 && swiperEvent.snapGrid[0] === -0;
          swiperEvent.wrapperEl.classList.toggle('secondary-navigation__swiper-wrapper--center', shouldBeCentered)
        }

        const updateScrollClasses = (swiperEvent) => {
          const swiperContainer = swiperEvent.el;
          const isAtStart = swiperEvent.isBeginning;
          const isAtEnd = swiperEvent.isEnd;
          
          swiperContainer.classList.toggle('at-start', isAtStart);
          swiperContainer.classList.toggle('at-end', isAtEnd);
        }

        // swiper initialization
        this.swiper = new Swiper(this.swiperEl, {
          loop: false,
          slidesPerView: 'auto',
          spaceBetween: 0,
          init: false,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
        });

        this.swiper.on('afterInit', scrollToActiveSlide)
        this.swiper.on('init', updateScrollClasses)
        this.swiper.on('slideChange', updateScrollClasses)
        this.swiper.on('reachBeginning', updateScrollClasses)
        this.swiper.on('reachEnd', updateScrollClasses)
        this.swiper.on('resize', updateScrollClasses)
        if (this.dataCenterSlides){
          this.swiper.on('init', centerSlides)
          this.swiper.on('resize', centerSlides)
        }
        
        // init
        this.swiper.init();
      }

      disconnectedCallback() {
        this.swiper?.destroy(true, true);
      }

    },
  );
}
